import "./footer.css";
import Footerlogo from "../../myimgs/nivora_logo.png";
import qrs from "../../myimgs/Layer_1 (22).png";
import twit from "../../myimgs/twit.png";
import { Link } from "react-router-dom";

import mobimg from "../../myimgs/mobile_11.png";
import play from "../../myimgs/Play app 1.png";
import app from "../../myimgs/Play app 2.png";
const Footer = () => {
  return (
    <>
      <section className="w-full bg-white py-16 txthombotmcs">
        <div className="container contr">
          <div className="row">
            <div className="col-md-6 tebtmleft">
              <img src={mobimg} alt="" />
            </div>
            <div className="col-md-6 txthombotm">
              <h3>Twoffers, Wherever You Are</h3>
              <p>
                Your next deal is always in reach. With the Twoffers app, you
                can browse, offer, and close on the go.
              </p>
              <div className="flxname">
                <Link to="https://play.google.com/store/apps/details?id=com.twoffers">
                  <img src={play} alt="" />
                </Link>
                <Link to="https://apps.apple.com/ae/app/twoffers/id6751880823">
                  <img src={app} alt="" />
                </Link>
              </div>
              <div className="qrimg">
                <img src={qrs} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer className="footer bg-dark text-light pt-5">
        {/* Top CTA Section */}
        <div className="container mb-5 lopji">
          <div className="cta-box d-flex flex-column flex-md-row align-items-center justify-content-between p-4">
            <div>
              <h3 className="fw-bold">
                Get started today your next deal awaits!
              </h3>
              <p className="cta-link">
                Create your free Twoffers account to search, save, and Offer on
                properties you love.
              </p>
            </div>
            <Link to="/login">
              <button className="btn btn-primary btn-lg mt-3 mt-md-0">
                Get Started Free
              </button>
            </Link>
          </div>
        </div>

        {/* Main Footer Content */}
        <div className="container pb-4 footers">
          <div className="row">
            {/* Logo & About */}
            <div className="col-md-3 mb-4">
              <img src={Footerlogo} alt="" className="footerimg" />
              <p>
                A trusted platform to buy, sell, and receive offers on verified
                properties all through secure online listings.
              </p>
              <div className="social-icons d-flex gap-3 mt-3">
                <Link to="/"></Link>
                <Link to="/"></Link>
                <Link to="/"></Link>
                <Link to="/"></Link>
              </div>
            </div>

            {/* Useful Links */}
            <div className="col-md-3 mb-4">
              <h6 className="fw-bold">USEFULL LINK</h6>
              <ul className="list-unstyled">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/buyer">Buy Property</Link>
                </li>
                <li>
                  <Link to="/profile">Sell Property</Link>
                </li>
                <li>
                  <Link to="/contactus">Contact Us</Link>
                </li>
              </ul>
            </div>

            {/* Help */}
            <div className="col-md-3 mb-4">
              <h6 className="fw-bold">HELP</h6>
              <ul className="list-unstyled">
                <li>
                  <Link to="/profile">List A Home</Link>
                </li>
                <li>
                  <Link to="/support">FAQ</Link>
                </li>
                <li>
                  <Link to="/support">Support</Link>
                </li>
                <li>
                  <Link to="/termsandconditions">Terms & Conditions</Link>
                </li>
                <li>
                  <Link to="/privacypolicy">Privacy Policy</Link>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div className="col-md-3 mb-4">
              <h6 className="fw-bold">CONTACT US</h6>
              <ul className="list-unstyled contact-list socol">
                <li>
                  <img src={twit} alt="" />
                  support@twoffers.com
                </li>
              </ul>
            </div>
            <div className="prara">
              <p>
                The listing information presented herein is provided under
                copyright by the Canadian Real Estate Association (CREA). While
                the data is deemed reliable, it is not guaranteed to be accurate
                by either CREA or Twoffers. No warranties or representations,
                either express or implied, are made by Twoffers or its
                affiliates regarding the accuracy, completeness, or reliability
                of the information displayed on this page.
                <br></br>
                The REALTOR® trademark is owned and controlled by the Canadian
                Real Estate Association (CREA) and is used to identify real
                estate professionals who are members of CREA. The trademarks
                MLS®, Multiple Listing Service®, and the associated logos are
                also owned by CREA and designate professional real estate
                services provided by its members to facilitate the purchase,
                sale, and lease of properties through a cooperative selling
                system.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom CopyRight */}
        <div className="footer-bottom text-center py-3 border-top border-light">
          <small>All interactions on Twoffers are secured and encrypted.</small>
          <small>
            We value transparency, privacy, and real property connections.
          </small>
          <small>©2025 Twoffers . All Rights Reserved</small>
        </div>
      </footer>
    </>
  );
};

export default Footer;
